import React, { useState, useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import CalendarDropdown from '../../HATV/HATVDashboard/CalendarDropdown/CalendarDropdown';
import { useGetOptionsListQuery } from '../../../redux/services/optionMasterAPI';
import styles from './NotesAndDocuments.module.scss';
import ProgressNotes from './ProgressNotes/ProgressNotes';
import GoalActionPlanDocument from './Documents/GoalActionPlanDocument';
import { useProgressNotesAPI } from '../../CustomHooks/useProgressNotesAPI';
import { useDocumentsAPI } from '../../CustomHooks/useDocumentAPI';
import SuccessionPlan from '../PersonalInformation/SuccessionPlan/SuccessionPlan';

interface NotesAndDocumentsProps {}

const NotesAndDocuments: React.FC<NotesAndDocumentsProps> = () => {
  const growthPlanNotesAPI = useProgressNotesAPI('notesAndDocument');
  const successionPlanAPI = useDocumentsAPI('successionPlan');

  const {
    data: periodData,
    isLoading: optionLoading,
    isError: optionError,
  } = useGetOptionsListQuery({
    applicationCode: 'amw',
    optionMasterName: 'abo-noteperformanceyear',
  });

  const optionsData: OptionItem[] = periodData?.body?.options ?? [];

  const yearList = useMemo(() => {
    return optionsData.map(({ code }) => code);
  }, [optionsData]);

  const [selectedYear, setSelectedYear] = useState<string>('');

  useEffect(() => {
    if (yearList.length > 0 && !selectedYear) {
      setSelectedYear(yearList[0]);
    }
  }, [yearList, selectedYear]);

  const handleSelectedCode = (value: string) => {
    setSelectedYear(value);
  };

  return (
    <div className={`NAD_wrapper ${styles.NAD_wrapper}`} data-testid="notesdocument_testID">
      <div className={`content_inner ${styles.NAD_inner_wrapper}`}>
        <div className={styles.year_selector_wrapper}>
          <CalendarDropdown
            monthYearList={yearList}
            onselectionMonthYear={handleSelectedCode}
            selectedMonth={selectedYear}
            isOnlyYear={true}
            isLoading={optionLoading}
            isError={optionError}
          />
        </div>
        <div className={styles.section_wrapper}>
          <ProgressNotes
            api={growthPlanNotesAPI}
            type="notesAndDocument"
            selectedYear={selectedYear ? parseInt(selectedYear.substring(0, 4)) : 0}
          />
        </div>
        <div className={styles.section_wrapper}>
          <GoalActionPlanDocument selectedYear={selectedYear ? selectedYear.substring(2) : ''} />
        </div>
        <div className={styles.vsection_wrapper}>
          <SuccessionPlan api={successionPlanAPI} />
        </div>
      </div>
    </div>
  );
};

export default NotesAndDocuments;
